import { render, staticRenderFns } from "./beneficiario.vue?vue&type=template&id=61e91794&scoped=true"
import script from "./beneficiario.vue?vue&type=script&lang=js"
export * from "./beneficiario.vue?vue&type=script&lang=js"
import style0 from "./beneficiario.vue?vue&type=style&index=0&id=61e91794&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e91794",
  null
  
)

export default component.exports